import axios from 'axios';

import { BaseAPIService } from './base.api.service';

export class LandingPageAPIService extends BaseAPIService {
  private getBlogs: string = 'blog/posts/?count=3';
  private getPodcast: string = 'blog/podcast/?count=2';
  
  constructor() {
    super();
    this.axiosInstance = axios.create({
      baseURL: process.env.REACT_APP_API_BLOG_ENDPOINT
    });
    this.configureInterceptors();
  }

  public async getAllBlogs(
    getBlogRequest
  ) {
    const getBlogResponse = await this.get(
      this.getBlogs,
      true,
      getBlogRequest
    );
    return getBlogResponse;
  }

  public async getAllPodcast(
    getPodcastRequest
  ) {
    const getPodcastResponse = await this.get(
      this.getPodcast,
      true,
      getPodcastRequest
    );
    return getPodcastResponse;
  }
}
